const types = {
  error: "ERROR",
  miniSuccess: "MINI_SUCCESS",
  success: "SUCCESS",
  warning: "WARNING",
  info: "INFO",
};

export { types };
